<label data-toggle-option [attr.data-size]="size()">

  <!--  Control  -->
  <span data-control>
    <ng-content />
  </span>

  <span data-content>
    <!-- Label -->
    <span data-label>{{ label() }}</span>

    <!--  Description  -->
    @if (description()) {
      <span data-description>{{ description() }}</span>
    }
  </span>
</label>
